import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AuthCallback from "@/pages/admin/AuthCallback";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Refund from "@/pages/legal/Refund";
import Cookies from "@/pages/legal/Cookies";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "sonner";
import { apiClient } from "@/lib/api";

function ProtectedAdmin({ children }) {
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setStatus("checking");
      return;
    }
    apiClient
      .get("/auth/me", { withCredentials: true })
      .then((r) => setStatus(r.data?.is_admin ? "ok" : "forbidden"))
      .catch(() => setStatus("login"));
  }, []);
  if (status === "checking")
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-zinc-500 font-mono text-xs tracking-[0.3em] uppercase">
        Verifying...
      </div>
    );
  if (status === "login") return <Navigate to="/admin/login" replace />;
  if (status === "forbidden")
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white px-6 text-center">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500 mb-4">
          403 · Restricted
        </div>
        <h1 className="font-display text-4xl uppercase tracking-tight">
          Access Denied
        </h1>
        <p className="mt-4 text-zinc-400 max-w-md">
          Your account is not on the operations allowlist.
        </p>
        <a href="/" className="mt-8 font-mono text-xs tracking-[0.3em] uppercase border border-white px-6 py-3 hover:bg-white hover:text-black transition">
          Return Home
        </a>
      </div>
    );
  return children;
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedAdmin>
            <AdminDashboard />
          </ProtectedAdmin>
        }
      />
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/refund" element={<Refund />} />
      <Route path="/legal/cookies" element={<Cookies />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-black text-white min-h-screen">
      <BrowserRouter>
        <AppRouter />
        <CookieBanner />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
